import React, { useState, useEffect } from 'react';
import InputField from '../../../../../common/InputField';
import CommonCheckBox from '../../../../../common/CommonCheckBox';
import SelectOption from '../../../../../common/SelectOption';
import useInputValidator from '../../../../../../hooks/useInputValidator';
// import TimeRangePicker from '../../../../../common/TimePickerWithHourly/TimeRangePicker';
import TimeRangePicker from '../../../../../common/TimePickerWithHourly/TimeRangePicker';
import { Form } from 'antd';
// import {days} from "../../../../../common/constants";
import { dailyPricingOptionValidation } from '../../../../../../helper/spaceFormValidation';
import { useSelector } from 'react-redux';

const BlockPricingOption = ({ paymentOptionIndex, paymentOptionId, form, isEdit}) => {
  const formFields = isEdit ? form.getFieldValue() : null;
  const { value, handleChange } = useInputValidator({
    minimumBookingPeriod: false
  });
  const [timePickers, setTimePickers] = useState([{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  const [selectedDays, setSelectedDays] = useState([]);
  const days = useSelector((state)=>state.space?.pricingOptionsArray?.data?.filter(days=> days.chargingType==paymentOptionId)[0]?.pricingOptions || []);
  const onSelectItems = days => {
    handleChange(days, [{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
    setSelectedDays([...selectedDays, days]);
  };
  const [dateSelectionOptions, setDateSelectionOptions] = useState(days);
  const {pricingOptionsArray} = useSelector((state)=> state.space || []);

  useEffect(() => {
    if(isEdit && pricingOptionsArray?.fetching){
      const pricingOptions = formFields?.chargings?.[paymentOptionIndex]?.pricingOptions;
      pricingOptions && Object.entries(pricingOptions).forEach(
          ([key, data]) =>  {
            value[key] = []
            data.forEach(val => {
              value.pricePerHour = val.pricePerHour;
              value[key].push([{ startTime: val.startTime, endTime: val.endTime }]);
            })
          }
      );
      formFields?.meetOrTrain?.blockOption?.days && setSelectedDays(formFields?.meetOrTrain?.blockOption?.days);
    }
    return () => {
      setSelectedDays([]);
      form.setFieldsValue({meetOrTrain: {blockOption: { days: []}}});
    }
  },[formFields?.id]);

  useEffect(() => {
    setDateSelectionOptions(dailyPricingOptionValidation(days, selectedDays));
  }, [selectedDays]);

  const hours = [1, 2, 3, 4, 5, 6, 7, 8];
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!'
    }
  ];

  useEffect(()=> {
    let chargings =  form.getFieldValue(['chargings']);
    let chargingType =  form.getFieldValue([ 'chargings', paymentOptionIndex, 'chargingType', 'id']);
    if(!chargingType){
      if(!chargings) chargings = [];
      chargings = [...chargings ,{
         chargingType: { 
           id : paymentOptionId
         }
       }];
    form.setFieldsValue({
      chargings
    })  
    }
  }, [])

  const validate = (rule, value) => {
    if (!value) {
      return Promise.reject('Please Fill Input Field!');
    }
    if (isNaN(value)) {
      return Promise.reject('Price must be Numbers');
    }
    return Promise.resolve();
  };
  const numberRule = [
    {
      required: true,
      validator: validate
    }
  ];

  const setDays = day => {
    setSelectedDays([...selectedDays, day]);
    handleChange(day, [{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  };
  const deselectItems = item => {
    setSelectedDays(selectedDays.filter(i => i !== item));
  };
  return (
    <>
      {/*<SelectOption*/}
      {/*  isMultiple={false}*/}
      {/*  name={['meetOrTrain', 'blockPricingOption', 'discountApplicable']}*/}
      {/*  placeholder={'Discount applicable after (Block)'}*/}
      {/*  rules={rules}*/}
      {/*  label={'Discount applicable after (Block)'}*/}
      {/*  values={hours}*/}
      {/*  handleOnSelect={null}*/}
      {/*/>*/}
      {/*<InputField*/}
      {/*  name={['meetOrTrain', 'blockPricingOption', 'discount']}*/}
      {/*  label={'Discount %'}*/}
      {/*  rules={rules}*/}
      {/*/>*/}
      <Form.Item name={['chargings', paymentOptionIndex, 'chargingType', 'id']}>
      </Form.Item>
      <h3>Block Price</h3>
      <SelectOption
          isMultiple={true}
          name={['meetOrTrain', 'blockOption', 'days']}
          placeholder={'Days'}
          rules={rules}
          label={'Days'}
          values={days}
          handleOnSelect={onSelectItems}
          handleOnDeselect={deselectItems}
      />

      {/*{selectedDays.map(day =>*/}
      {/*  value?.[day].map((picker, index) => (*/}
      {/*    <Form.Item label={day} name={['meetOrTrain', 'blockPricingOption', 'price', day, index]}>*/}
      {/*      <TimeRangePicker*/}
      {/*        key={index}*/}
      {/*        pickers={value[day]}*/}
      {/*        setTimePicker={handleChange}*/}
      {/*        index={index}*/}
      {/*        day={day}*/}
      {/*        type={'Block'}*/}
      {/*      />*/}
      {/*    </Form.Item>*/}
      {/*  ))*/}
      {/*)}*/}
      {selectedDays.map((day, index) => (
        value[day] && value[day].length > 0 ? value?.[day].map((picker, index) => (
          <>
            <Form.Item label={day} name={['chargings', paymentOptionIndex, 'pricingOptions' , day, index]}>
              <TimeRangePicker
                  key={index}
                  pickers={value[day]}
                  setTimePicker={handleChange}
                  index={index}
                  day={day}
                  isEdit={isEdit}
                  block={true}
              />
            </Form.Item>
          </>
      )) : null
      ))}
    </>
  );
};

export default BlockPricingOption;
